/* PACKAGES */
import { motion } from "framer-motion";

/* CONTAINER ANIMATION */
const containerAnimation = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 1 },
  },
};

/* DIV ANIMATION */
const animation = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
  hidden: {
    opacity: 0,
    y: 20,
    transition: {
      type: "spring",
      damping: 12,
      delay: 1,
      stiffness: 100,
    },
  },
};

const CancellationPolicy = () => {
  return (
    <motion.section
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
      className="bg-white py-6 xl:py-14 lg:py-14"
    >
      {/* CONTENT */}
      <motion.div variants={animation} className="p-0">
        <div className="container">
          <h1 className="text-4xl font-fraunces-black tracking-tight">
            Cancellation Policy
          </h1>
          <div className="mt-10">
            <p className="text-lg font-source font-normal text-black">
              At Food Farmacy, we strive to provide our customers with the
              highest quality healthy food products and exceptional service. We
              understand that circumstances may arise that require you to cancel
              your order. To ensure a seamless cancellation process and maintain
              customer satisfaction, we have outlined our cancellation policy
              below:
            </p>

            {/* POINT ONE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Order Cancellation Window
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Customers may cancel their order within 24 hours of placing it.
                Any cancellation requests made after this period may not be
                accommodated.
              </p>
            </div>

            {/* POINT TWO */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Cancellation Procedure
              </h5>
              <p className="text-lg font-source font-normal text-black">
                To cancel your order, please contact our customer support team
                via email at{" "}
                <a
                  href="mailto:support@foodfarmacy.com"
                  className="text-blue-500 font-source font-semibold"
                >
                  support@foodfarmacy.com
                </a>{" "}
                or by phone at{" "}
                <a
                  href="tel:918792795765"
                  className="text-blue-500 font-source font-semibold"
                >
                  +91 8792795765
                </a>
                . Please provide your order number and reason for cancellation.
              </p>
            </div>

            {/* POINT THREE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Refund Policy
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Upon successful cancellation of your order within the specified
                time frame, a full refund will be issued to the original payment
                method used for the purchase. Please allow 3-5 business days for
                the refund to reflect in your account.
              </p>
            </div>

            {/* POINT FOUR */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Late Cancellation
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Cancellation requests made after the 24-hour window may not be
                accepted. However, we encourage you to still reach out to our
                customer support team, and we will do our best to accommodate
                your request.
              </p>
            </div>

            {/* POINT FIVE */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Order Modification
              </h5>
              <p className="text-lg font-source font-normal text-black">
                If you wish to modify your order instead of cancelling it
                entirely, please contact us within the cancellation window, and
                we will assist you with making the necessary changes.
              </p>
            </div>

            {/* POINT SIX */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Out-of-Stock Items
              </h5>
              <p className="text-lg font-source font-normal text-black">
                In the rare event that an item you've ordered becomes
                unavailable after purchase, we will notify you immediately and
                provide options for a replacement or cancellation. If you choose
                to cancel, a full refund will be issued.
              </p>
            </div>

            {/* POINT SEVEN */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Subscription Cancellation
              </h5>
              <p className="text-lg font-source font-normal text-black">
                For subscription-based orders, customers have the option to
                cancel their subscription at any time. However, please note that
                cancellations made after an order has been processed for
                shipment may not take effect until the following billing cycle.
              </p>
            </div>

            {/* POINT EIGHT */}
            <div className="mt-5">
              <h5 className="text-2xl font-source font-bold text-black">
                Exceptions
              </h5>
              <p className="text-lg font-source font-normal text-black">
                Food Farmacy reserves the right to refuse or limit cancellations
                in cases of suspected fraud, abuse of the cancellation policy,
                or any other circumstances deemed necessary by the management.
              </p>
            </div>

            <div className="mt-10">
              <p className="text-lg font-source font-normal text-black">
                By placing an order with Food Farmacy, you agree to abide by the
                terms and conditions of this cancellation policy. We appreciate
                your understanding and cooperation in ensuring a smooth and
                satisfactory shopping experience for all our valued customers.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
};

export default CancellationPolicy;
